/* eslint-disable func-names */

const controlSubmit = (captchaParams) => {
    const { response, captcha } = captchaParams;

    $(captchaParams.submit).off().on('click', (e) => {
        if (response.length === 0) {
            captcha
                .parent()
                .find('.invalid-feedback.d-none')
                .removeClass('d-none');
            e.stopPropagation();
            e.preventDefault();
        } else {
            captcha
                .parent()
                .find('.invalid-feedback:not(.d-none)')
                .addClass('d-none');
        }
    });
};

const clousureResponse = (captchaParams) => {
    const captchaobj = captchaParams;

    return (response) => {
        captchaobj.response = response;

        controlSubmit(captchaobj);
    };
};

const onloadCallback = function () {
    const captchaClass = '.marshall-recaptcha';
    const captchaContainer = $('.marshall-recaptcha-container');

    if (captchaContainer.length) {
        setTimeout(() => {
            // each all captcha for render in case of more than one captcha
            // the grecaptcha.render method only render the first one
            captchaContainer.find(captchaClass).each((indx, val) => {
                const $captcha = $(val);
                const key = $captcha.data('sitekey');
                const submit = $captcha.data('elemsubmit');
                const renderName = $captcha.data('name');
                const captchaParams = {
                    submit: submit,
                    captcha: $captcha,
                    response: '',
                };
                const clousureForResponse = clousureResponse(captchaParams);

                window.grecaptcha.render(renderName, {
                    sitekey: key,
                    callback: clousureForResponse,
                });

                controlSubmit(captchaParams);
                $captcha.removeData('sitekey');
            });
        }, 300);
    }
};

module.exports = {
    onloadCallback,
};
